export function setIsWaypointLimitReached(state, payload) {
    state.isWaypointLimitReached = payload;
}

export function setWaypointPosition(state, payload) {
    state.waypointPositions[payload.position] = payload.value
}

export function resetWaypointPosition(state) {
    state.waypointPositions = {
        start: false,
        interim: false,
        end: false,
    };
}

export function upSearchId(state) {
    state.searchId++;
}

export function setLastSearches(state, payload) {
    state.lastSearches = payload;
}

export function setLastRoutes(state, payload) {
    state.lastRoutes = payload;
}